import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import * as utils from '@chronos/utils';

import useResizable from '@chronos/ui-toolkit/hooks/useResizable';

import * as S from './styled';

export default function LabelList({
  labels,
  isLarge,
  isExpanded,
  onResize,
  onExpand,
}) {
  const ref = useRef();
  useResizable(ref, onResize);

  return (
    <S.LabelList ref={ref}>
      {labels.map((label) => (
        <S.Label key={label.id || label.value}>
          <S.LabelButton
            isLarge={isLarge}
            isExpanded={isExpanded}
            color={label.color}
            onClick={(event) => onExpand(event)}
          >
            {isExpanded && label.name}
          </S.LabelButton>
        </S.Label>
      ))}
    </S.LabelList>
  );
}

LabelList.propTypes = {
  isLarge: PropTypes.bool,
  isExpanded: PropTypes.bool,
  onResize: PropTypes.func,
  onExpand: PropTypes.func,
  labels: PropTypes.array,
};

LabelList.defaultProps = {
  isLarge: false,
  isExpanded: false,
  onResize: () => {},
  onExpand: () => {},
  labels: [],
};
